import getStore from '../store/store';
import { QuickAddViewState } from 'owa-todo-views';

export default function getQuickAddViewState(): QuickAddViewState {
    return getStore().quickAddViewState;
}
